/**
 * Define constant veriable
 *
 * @type {{ PARENT_NODE: string; TAG_NAME: string; DATA_KEYWORD_ID: string; INNER_TEXT: string; DELETE: string; CONTENT_COPY: string; GENERATE_CUSTOM_GUID: string; }}
 */
const _decoratorsConstant = {
  PARENT_NODE: 'parentNode',
  TAG_NAME: 'tagName',
  DATA_KEYWORD_ID: 'data-keyword-id',
  INNER_TEXT: 'innerText',
  SECTION_NAME: 'data-section-name',
  DELETE: 'delete',
  CONTENT_COPY: 'content_copy',
  CHECK_BOX: 'check_box',
  SWAP_VERT: 'swap_vert',
  PREV_REFERENCE: 'chevron_left',
  NEXT_REFERENCE: 'chevron_right',
  GENERATE_CUSTOM_GUID: 'generatecustomguid',
  CURRENT_SITE: 'currentSite',
  DATA_NUMBER_CITATION_ID: 'data-number-citation-id',
  DATA_UNNUMBER_CITATION_ID: 'data-unnumber-citation-id',
  DATA_CITATION_ID: 'data-citation-id',
  UNNUMBERED_CITATION_CLASS: 'unnum-block',
  NUMBERED_CITATION_CLASS: 'num-block',
  CITATION_TEXT: 'citation-text',
  CITATION_SELECTED_CLASS: 'citation-selected-text',
  CITATION_ERROR_CLASS: 'citation-error-text',
  BG_CLASS: 'bg-blue-color',
  DISABLE_BLOCK: 'disable-block',
  DISABLE_NUM_BLOCK: '.num-block.disable-block',

  KEYWORD_REL: 'skosxl:altLabel',
  KEYWORD_PROPERTY: 'skosxl:literalForm',
  KEYWORD_DEF_PROPERTY: 'skos:definition',
  KEYWORD_CONTENT_PROPERTY: 'content',
  KEYWORD_ABOUT_PROPERTY: 'about',
  KEYWORD_LABLE: 'skosxl:Label',
  HIGHTLIGHT_KEYWORD_ON_SCROLL: 'highlight-keyword-onscroll',
  CITATION_PREF_LABEL: 'skos:prefLabel',

  NUMBERED_CITATION_CSS: 'numbered-citation',
  DATA_CITATION_COUNT: 'data-citationcount',
  HIDE_ACTION_ICONS: 'hide-action-icons',
};

const _trackChangeConstant = {
  TRACK_CHANGES_AND_COMMENTS_DATA: 'trackchangesandcommentsdata',
  TRACK_CHANGES_AND_COMMENTS_INVOLVED_USERS:
    'trackChangesAndCommentsInvolvedUsers',
};

export const DecoratorsTrackChangeConstant =
  Object.freeze(_trackChangeConstant);
export const DecoratorsConstant = Object.freeze(_decoratorsConstant);
